export default __webpack_public_path__ + "static/media/roboto-v20-latin-regular.e464241b.eot";